module.exports = __webpack_public_path__ + "static/media/mobile-welcome1.b6eabc32.png";